import React, { useEffect, useMemo, useState } from "react";
import { PDFViewer } from "@react-pdf/renderer";

// Custom.
import { PreviewProps } from "../global";
import { useStyles } from "./styles";
import { useStylesBase } from "../styles";
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import VoLoader from "@vocollege/components/dist/VoLoader";
import LanguageRepresentativeEducatorDiplomaTemplate from "./LanguageRepresentativeEducatorDiplomaTemplate";
import DownloadButton from "../components/DownloadButton";

let updatingTimer: number;

const LanguageRepresentativeDiplomaPreview: React.FC<PreviewProps> = (
  props,
) => {
  const { item, formState, id } = props;
  const classes = useStyles();
  const classesBase = useStylesBase();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>(null);

  // Methods.

  const document = useMemo(() => {
    return <LanguageRepresentativeEducatorDiplomaTemplate item={data} />;
  }, [data]);

  // Effects.

  useEffect(() => {
    setLoading(true);
    clearTimeout(updatingTimer);
    updatingTimer = window.setTimeout(() => {
      setData(item);
      setLoading(false);
    }, 2000);
  }, [item]);

  return (
    <div className={classes.root}>
      {id !== "skapa" && (
        <DownloadButton
          document={document}
          loading={loading}
          data={data}
          formState={formState}
        />
      )}
      <div className={classesBase.viewerWrapper}>
        {(loading || !data) && (
          <div>
            {
              <VoLoader
                className={classesBase.loader}
                title={I18n.get.misc.rendering}
                noOverlay
              />
            }
          </div>
        )}
        {!loading && data && (
          <PDFViewer showToolbar={false} className={classesBase.viewer}>
            {document}
          </PDFViewer>
        )}
      </div>
    </div>
  );
};
export default LanguageRepresentativeDiplomaPreview;
